import React from 'react'
import AllUserList from '../../features/admin/AllUserList'

const AllUserListPage = () => {
  return (
    <AllUserList />
  )
}

export default AllUserListPage